import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { CMSSteps } from '@/api/cms/restrictions';
import { ImageComponent } from '@/components/Image';
import { StepsByGroup } from '@/modules/restrictions/components/StepsByGroup';
import { ScHowTo } from './styled';

interface IHowToProps {
  namespace: string;
  sections: CMSSteps[] | null;
  hideGamesCountLabel?: boolean;
  hideDescription?: boolean;
}

export const HowTo: FC<IHowToProps> = ({
  namespace,
  sections,
  hideGamesCountLabel,
  hideDescription,
}) => {
  const { t } = useTranslation(namespace);

  if (!sections) return null;

  return (
    <ScHowTo>
      <div className="content">
        <div className="titleAccent">
          <ImageComponent alt="" fill src="/headline-promo/how-to-decor.svg" />
        </div>
        <StepsByGroup
          hideDescription={hideDescription}
          imgSize={{ width: 64, height: 64 }}
          label={
            hideGamesCountLabel
              ? undefined
              : t('howToParticipate.allGamesCount')
          }
          sections={sections}
          title={t('howToParticipate.title')}
        />
      </div>
    </ScHowTo>
  );
};
